import React, { Component } from "react";
import "./FormView.css";
import PropTypes from "prop-types";
import SidePanel from "../SidePanel";

export default class FormView extends Component {

    render() {
        const { sideContent, topContent, content, mapContent, split50, split35 } = this.props;
        const noSide = !sideContent;

        return (
            <div className={`FormView ${noSide ? 'FormView-noSide' : ''} ${split50 ? 'FormView-split50' : ''} ${split35 ? 'FormView-split35' : ''}`}>
                {topContent && (
                    <div className={`FormView-top ${sideContent ? 'FormView-top-split' : ''}`}>
                        {topContent}
                    </div>
                )}
                {sideContent && (
                    <div className="FormView-side">
                        <SidePanel
                            content={sideContent}
                        />
                    </div>
                )}
                <div className="FormView-content">
                    {content}
                </div>
                {mapContent && (
                    <div className="FormView-map">
                        {mapContent}
                    </div>
                )}
            </div>
        );
    }

}

FormView.propTypes = {
    content: PropTypes.node,
    sideContent: PropTypes.node,
    mapContent: PropTypes.node
}